<template>
    <mm-tab-title v-model="tab" :titles="titles">
        <el-button slot="save" size="medium" type="primary" @click="submit">save</el-button>
        <el-form ref="form" :model="result" size="small" label-width="200px">
        
            <div v-show="tab===1">
                <el-form-item label="Advertiser" prop="adv_id">
                    <mm-adv-select v-model="result.adv_id" />
                </el-form-item>
                <el-form-item label="Channel" prop="channel_id">
                    <mm-channel-select v-model="result.channel_id" />
                </el-form-item>
                <el-form-item label="Geo" prop="geo">
					<mm-offer-geos v-model="result.geo" />
                </el-form-item>
                <el-form-item label="Package Name" prop="package_id">
                    <el-input v-model="result.package_id" />
                </el-form-item>
                <el-form-item label="Offer Price" prop="price" >
                    <el-input type="number" @mousewheel.native.prevent v-model="result.price"/>
                </el-form-item>
                <el-form-item label="Status" prop="status">
                    <mm-radio v-model="result.status" :options="statusOptions"/>
                </el-form-item>
            </div>
            
            <div v-show="tab===2">
                <el-form-item label="Advertiser" prop="adv_id">
                    <mm-adv-select v-model="batch.adv_id" />
                </el-form-item>
                <el-form-item label="Channel" prop="channel_id">
                    <mm-channel-select v-model="batch.channel_id" />
                </el-form-item>
                <!-- <el-form-item label="Top Offers">
                    <mm-file-xlsx v-model="upload" :on-change="formatData()">upload</mm-file-xlsx>
                </el-form-item> -->
                <el-form-item label="Top Offers">
                    <el-input v-model="offer_list" :placeholder="tips" type="textarea" :on-blur="format()" :rows="15" />
                </el-form-item>
            </div>
        </el-form>

    </mm-tab-title>


</template>

<script>
export default {
	props: ["edit"],
	watch:{
		'$route' (to, from) {
			this.loadData();
        },
	},
	data() {
        const statusOptions = [{label:'ACTIVE',value:'active'},{label:'PAUSED',value:'paused'}];
		return {
			result: {
				status: 'active',
            },
            batch:{},
            upload:[],
            statusOptions,
			file_list:[],
            tab: 1,
            // use_upload: false,
            titles:[],
            offer_list: '',
            tips: `eg:\npackage_id\tgeo\tprice\nxxx.xxx\tXX\t1.0`
		};
	},
	methods: {
		async submit() {
            const id= this.$route.query['id'];
            if (id) {
                const result = this.result;
                if (!(result.adv_id || result.channel_id)
                 || !result.geo
                 || !result.package_id
                 || !result.price
                 || !result.status) {
                     this.$message({
                         type: 'error',
                         message: 'Missing params'
                     })
                     return;
                 }
                 await this.$post('/topOffer/update', {id: id, update:result});
                 return;
            }
			if (this.tab === 1) {
                const result = this.result;
                if (result.adv_id && result.channel_id) {
                    this.$message({
                        type: 'error',
                        message: 'Select one of adv/channel'
                    })
                    return;
                }
                if (!(result.adv_id || result.channel_id)
                 || !result.geo
                 || !result.package_id
                 || !result.price
                 || !result.status) {
                     this.$message({
                         type: 'error',
                         message: 'Missing params'
                     })
                     return;
                 }
                 await this.$post('/topOffer/create', result);
            } else {
                const batch = this.batch;
                const upload = this.upload;
                if (batch.adv_id && batch.channel_id) {
                    this.$message({
                        type: 'error',
                        message: 'Select one of adv/channel'
                    })
                    return;
                }
                if (!(batch.adv_id || batch.channel_id)
                 || !upload[0]
                 || !upload[0].geo
                 || !upload[0].package_id
                 || !upload[0].price) {
                     this.$message({
                         type: 'error',
                         message: 'Missing params,check out package_id/geo/price or adv_id/channel_id'
                     })
                     return;
                }
                await this.$post('/topOffer/batchCreate', {batch, upload});
            }
		},
		async loadData() {
            const id= this.$route.query['id'];
			if (id) {
                this.result = await this.$post('/topOffer/detail',{id:id});
                if (this.result.adv_id === 0) {
                    this.result.adv_id = '';
                } else if (this.result.channel_id === 0) {
                    this.result.channel_id = '';
                }
			}
		},
        async formatData() {
            const len = this.upload.length;
            if (len !== 0) {
                this.$message({
                    type: 'info',
                    message: `${len} Top Offers`
                })
            }
        },
        format() {
            if (this.offer_list === '' || this.tab === 1) {
                return;
            }
            const list = this.offer_list.split('\n');
            const header = [];
            const rows = [];
            for (const num in list) {
                const r = list[num].split('\t');
                if (num == 0) {
                    for (const h of r) {
                        if (!/package_id/.test(h) && !/geo/.test(h) && !/price/.test(h)) {
                            this.$message({
                                type: 'error',
                                message: `Header Error`
                            });
                            return;
                        }
                        header.push(h.replace(/\s/g, ''));
                    }
                } else {
                    if (r[0] && r[1] && r[2]) {
                        rows[num-1] = {};
                        rows[num-1][header[0]] = r[0].replace(/\s/g, '');
                        rows[num-1][header[1]] = r[1].replace(/\s/g, '');
                        rows[num-1][header[2]] = r[2].replace(/\s/g, '');
                    }
                }
            }
            const len = rows.length;
            if (len !== 0) {
                this.$message({
                    type: 'info',
                    message: `${len} Top Offers`
                })
            }
            this.upload = rows;
        }
	},
    
	beforeMount() {
        const id = this.$route.query['id'];
        this.titles.push('Base Info');
        if (id) {
            this.loadData();
        } else {
            this.titles.push('Batch Addition');
        }
	}
};
</script>